import { Component } from "react";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import { adminlimit } from "../Settings/Config";
import { showContaimerLoader, encodeValue, removeItem, showPageCount, hasPermission, addModule } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const module = "grade";
const modulePath = "/grade";
const moduleName = "Grade";
const moduleID = 7;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadList(1);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    const params = {
      params: "limit=" + this.state.pageLimit.value + "&offset=" + offset + addParams,
      url: `${module}`,
    };
    this.props.getListData(params);
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `${modulePath}/edit`,
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      if(this.state.currentPage!==value) {
        this.setState(
          {
            loading: true,
            currentPage: value,
          },
          () => {
            this.loadList(value);
          },
        );
      }
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  {addModule(moduleID, moduleName, modulePath)}
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                            </div>
                            <div className="col-md-3">
                              <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                                Search
                              </a>
                              <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div>
                          <div className="card-header">
                            {parseInt(this.state.totalPage) > 0 &&
                              showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                          </div>
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                <thead className="table-primary">
                                  <tr>
                                    {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                      <th style={{ width: "50px" }} className="text-center">
                                        Actions{" "}
                                      </th>
                                    )}
                                    <th style={{ width: "20px" }}>S.No</th>
                                    <th>Grade</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.loading ? (
                                    <tr>
                                      <td colSpan={3}>{showContaimerLoader()}</td>
                                    </tr>
                                  ) : this.state.listdata.length > 0 ? (
                                    this.state.listdata.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                            <td className="text-center text-nowrap align-middle">
                                              {hasPermission(moduleID, "edit") && (
                                                <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                                  <i className="fa fa-pencil-square-o"></i>
                                                </a>
                                              )}
                                              {hasPermission(moduleID, "delete") && (
                                                <a href="/" className="delete_record" data="Delete" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                                  <i className="fa fa-trash"></i>
                                                </a>
                                              )}
                                            </td>
                                          )}
                                          <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                          <td>{item.gradeExp}</td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td className="text-center" colSpan={3}>
                                        No {moduleName} Found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {parseInt(this.state.totalPage) > 1 && (
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
